import { FunctionComponent, useState } from "react";
import ModalFiltro from "../../../../../components/modalFiltros";
import styled from "styled-components";
import { Button, FormLabel, Switch } from "@mui/material";
import { UseList } from "../../context/getEvents"
interface ModalFilterProps {
}


const ItemGrid = styled.section`
  display: flex;
  gap: 4px;
  align-items: center;
`

const ModalFilter: FunctionComponent<ModalFilterProps> = () => {

  const [possuiincritos, setPossuiInscritos] = useState<boolean>(false);
  const [ativo, setAtivo] = useState<boolean>(false);

  const { getWithParams, refecth } = UseList();

  const submit = async () => {

    await getWithParams({
      possuiincritos,
      ativo
    })

  }

  const res = () => {
    setPossuiInscritos(false);
    setAtivo(false);
    refecth();
  }

  return (<>
    <ModalFiltro>
      <>
        <section
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 5,
            height: 50,
            borderBottom: '1px solid #ccc'
          }}
        >
          <h2>Filtros</h2>
        </section>
        <ItemGrid>
          <FormLabel htmlFor="">Ativo:</FormLabel>
          <Switch checked={ativo} onClick={() => setAtivo(!ativo)} />
        </ItemGrid>
        <ItemGrid>
          <FormLabel htmlFor="">Possui Inscritos:</FormLabel>
          <Switch checked={possuiincritos} onClick={() => setPossuiInscritos(!possuiincritos)} />
        </ItemGrid>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            color="error"
            onClick={res}
          >
            Limpar
          </Button>
          <Button
            sx={{
              boxShadow: 'none'
            }}
            onClick={submit}
          >
            Enviar
          </Button>
        </div>
      </>
    </ModalFiltro>
  </>);
}

export default ModalFilter;
